<div class="modal-header relative">
  <h4 class="modal-title-top20"> {{'customerService.createTicket'|cxTranslate}}</h4>
  <div class="cls-btn">
    <img src="../../assets/icons/close.png" (click)="close()" alt="" />
  </div>
</div>
<div class="modal-body">
  <div class="create-ticket-tab-content">
    <div class="row">
      <div class="col-lg-12 col-md-12 col-ms-12 col-xs-12 custom-media-col">
        <!-- TAB CONTENT STARTS FROM HERE -->
        <div id="createNewTicketTabContent" class=""  [formGroup]="ticketForm">
          <div class="row">
            <div class="col-lg-12 col-md-12 col-ms-12 col-xs-12 form-group">
              <div class="suggestion-theme create-ticket">
                <label class="bold-copy-1 ticket-type-label">{{'customerService.selectType'|cxTranslate}}</label> 
                <ng-select
                [items]="ticketTypeList"
                bindLabel="name"
                bindValue="id"
                [multiple]="false"
                name="selectedType"
                placeholder="Por favor selecione..."
                [(ngModel)]="selectedType"
                [searchable]="false"
                formControlName="ticketType"
                [ngClass]="{
                  invalidClassDrp:
                  !ticketForm.get('ticketType').value && createTicketClicked
                }"
              >
              </ng-select>
              </div>
              <span class="txt-error" *ngIf="
              !ticketForm.get('ticketType').value && createTicketClicked
            ">{{ "customerService.fieldReq" | cxTranslate }}</span>
            </div>
          </div>                            
          <div class="" id="suggestiontab" *ngIf="selectedType!=undefined && selectedType!=null && selectedType!=''">
            <div>
              <div class="row">
                <div class="col-lg-6 col-md-6 col-ms-6 col-xs-12 form-group" id="suggestionDiv">
                  <div class="suggestion-theme create-ticket">
                    <label class="bold-copy-1 ticket-type-label">{{'customerService.selectTheme'|cxTranslate}}</label>
                    <ng-select
                    [items]="subTicketCategoryList"
                    bindLabel="name"
                    bindValue="code"
                    [multiple]="false"
                    name="selectedTheme"
                    placeholder="Por favor selecione..."
                    [(ngModel)]="selectedTheme"
                    [searchable]="false"
                    formControlName="ticketTheme"
                    [ngClass]="{
                      invalidClassDrp:
                      !ticketForm.get('ticketTheme').value && createTicketClicked
                    }"
                  >
                  </ng-select>
                  </div>
                  <span class="txt-error" *ngIf="
                  !ticketForm.get('ticketTheme').value && createTicketClicked
                ">{{ "customerService.fieldReq" | cxTranslate }}</span>
                </div>
                <div class="col-lg-6 col-md-6 col-ms-6 col-xs-12 form-group">
                  <div class="suggestion-theme create-ticket">
                    <label class="bold-copy-1 ticket-type-label">{{'customerService.selectBU'|cxTranslate}}</label>
                    <label *ngIf="b2bUnitList?.length===1" class="b2b-single-value" formControlName="ticketBU">{{selectedBU?.name}}</label>
                    <ng-select
                    [items]="b2bUnitList"
                    bindLabel="name"
                    bindValue="id"
                    [multiple]="false"
                    name="selectedBU"
                    placeholder="Por favor selecione..."
                    [(ngModel)]="selectedBU"
                    [searchable]="false"
                    formControlName="ticketBU"
                    [ngClass]="{
                      invalidClassDrp:
                      !ticketForm.get('ticketBU').value && createTicketClicked,
                      singleValue:b2bUnitList?.length===1}"
                  >
                  </ng-select>
                </div>
                <span class="txt-error" *ngIf="
                !ticketForm.get('ticketBU').value && createTicketClicked
              ">{{ "customerService.fieldReq" | cxTranslate }}</span>
              </div>
              </div>
              <div class="row">
                <div class="col-lg-12 col-md-12 col-ms-12 col-xs-12 ">
                  <div class="suggestion-desc">
                    <label class="bold-copy-1 ticket-type-label">{{'customerService.description'|cxTranslate}}</label>
                    <textarea id="description" name="description" [ngClass]="{
                      invalidClass:
                      !ticketForm.get('ticketDesc').value && createTicketClicked
                    }" maxlength="4000" formControlName="ticketDesc"></textarea>
                    <span class="txt-error" *ngIf="
                    !ticketForm.get('ticketDesc').value && createTicketClicked
                  ">{{ "customerService.fieldReq" | cxTranslate }}</span>
                  </div>

                </div>
                <div class="disclaimer-text ticket-type-label">
                  {{'customerService.disclaimerTxt'|cxTranslate}}</div>
              </div>
              <div class="row create-ticket-upload-section">
                <div class="col-xs-12 col-sm-4 col-md-4 col-lg-4 drag-drop-file-section-desktop file-upload-content" [ngClass]="{disableUpload:this.uploadedFilesData?.length===10}">
                  <img id="icon-upload" alt="" src="../../../assets/icons/ico-upload.png">
                  <label for="img" class="text browse-ticket">{{'customerService.fileUpload'|cxTranslate}}</label>
                  <input type="file" name="uploadfile" (change)="uploadFile($event)" id="img" style="display:none;"/>
                </div>
                <div class="col-xs-12 col-sm-8 col-md-8 col-lg-8 uploaded-file-section">
                  <div class="file row" id="uploaded_file3" *ngFor="let item of uploadedFilesData">
                    <span class="icon-pdf-summary pull-left"></span>
                    <a class="uploaded_filename pull-left" target="_blank" download="{{item?.fileName}}" [href]="sanitizer.bypassSecurityTrustUrl(item?.selectedBlobUrl)">{{item?.fileName}}</a>
                    <span class="icon-x-blue icon-cancel hidden-lg hidden-md hidden-sm" (click)="removeUploadedFile(item)"></span>
                  </div>
                </div>
              </div>
              <div class="permission-text ticket-type-label">
                {{'customerService.permissionTxt'|cxTranslate}}
              </div>
              <div class="row">
                <div class="col-lg-12 col-md-12 col-ms-12 col-xs-12 ">
                  <div class="check-box padding-none">
                    <input type="checkbox" class="email-checkbox" (change)="emailCheck($event.target.checked)" />
                    <label for="agreecheckbox" class="body-copy-1">{{'customerService.emailSend'|cxTranslate}}</label>
                  </div>
                </div>
              </div>
            
            <div class="button-content">
              <div class="row">
                <div class="hidden-xs col-lg-6 col-md-6 col-sm-6"></div>
                <div class="col-xs-12 col-lg-6 col-md-6 col-sm-6 pull-right">
                  
                <input type="button" value="CRIAR TICKET" (click)="createTicket()" class="sanofi-sapphire-button-primary-hl create-new-ticket">
                  
                </div>
              </div>
            </div>
          </div>
        </div>	
      </div>
    </div>
  </div>
  
</div>
</div>
